const TUNNEL_MSGING_DOMAIN = 'tunnel.msging.net';
export const asyncFetchMediaWithAuth = (mediaOwnerIdentity, requesterAuthorization) => {
    return async (document) => {
        const uri = getMediaUrlWithTunnel(document.uri, mediaOwnerIdentity);
        return fetch(uri, {
            headers: { authorization: requesterAuthorization },
            cache: 'force-cache',
        });
    };
};
const getMediaUrlWithTunnel = (uri, mediaOwnerIdentity) => {
    const url = new URL(uri);
    const [mediaOwnerIdentityName, mediaOwnerIdentityDomain] = mediaOwnerIdentity.split('@');
    if (mediaOwnerIdentityDomain.startsWith(TUNNEL_MSGING_DOMAIN)) {
        url.searchParams.append('tunnel', mediaOwnerIdentityName);
    }
    return url.toString();
};
